import { FC } from 'react';

import clsx from 'clsx';
import Lottie from 'lottie-react';

import loader from '../../../shared/assets/lotties/loader.json';

export interface LoaderProgressProps {
    loading?: boolean;
    fullScreen?: boolean;
}

const LoaderProgress: FC<LoaderProgressProps> = (props) => {
    return (
        <div
            className={clsx(
                props.loading ? 'block' : 'hidden',
                props.fullScreen ? 'fixed' : 'absolute',
                'left-0 right-0 bottom-0 top-0 backdrop-blur-xs backdrop-filter z-20',
            )}
        >
            <div className='h-32 w-32 left-1/2 top-1/2 absolute -translate-x-1/2 transform -translate-y-1/2'>
                <Lottie animationData={loader} loop autoplay />
            </div>
        </div>
    );
};

export default LoaderProgress;
